"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnnotationPopover = void 0;
const three_1 = require("three");
const CSS2DRenderer_1 = require("three/examples/jsm/renderers/CSS2DRenderer");
const UiElements_1 = require("../../ui/UiElements");
class AnnotationPopover {
    constructor(annotation) {
        this._name = annotation.name;
        this._content = annotation.content;
        this._element = this.create(annotation);
    }
    get name() { return this._name; }
    set name(name) {
        this._name = name;
        if (this.nameEl) {
            this.nameEl.domEl.innerText = name;
        }
    }
    get content() { return this._content; }
    set content(content) {
        this._content = content;
        let textContent = content != null ? content : null;
        if (this.contentEl) {
            this.contentEl.setTextContent(textContent);
        }
    }
    get element() { return this._element; }
    set element(element) { this._element = element; }
    /**
     * Dispose object
     */
    dispose() {
        var _a, _b, _c;
        (_a = this.nameEl) === null || _a === void 0 ? void 0 : _a.domEl.remove();
        (_b = this.contentEl) === null || _b === void 0 ? void 0 : _b.domEl.remove();
        (_c = this._element.parent) === null || _c === void 0 ? void 0 : _c.remove(this._element);
    }
    ;
    /**
     * CSS2DObject to add to CSS2DRenderer
     */
    create(annotation) {
        const annotationPoint = new three_1.Vector3(annotation.annotationPoint.x, annotation.annotationPoint.y, annotation.annotationPoint.z);
        const annotationDiv = this.createAnnotationDiv(annotation);
        const css2DObject = new CSS2DRenderer_1.CSS2DObject(annotationDiv.domEl);
        css2DObject.position.copy(annotationPoint);
        css2DObject.visible = false;
        return css2DObject;
    }
    showImage(url) {
        var _a;
        (_a = this.imageContainerEl) === null || _a === void 0 ? void 0 : _a.addChild(new UiElements_1.ImageEl(url));
    }
    hideImage() {
        var _a, _b;
        //Remove all images
        //Start from the back if not it may skip one
        for (let i = ((_a = this.imageContainerEl) === null || _a === void 0 ? void 0 : _a.domEl.childElementCount) - 1; i >= 0; i--) {
            (_b = this.imageContainerEl) === null || _b === void 0 ? void 0 : _b.domEl.children[i].remove();
        }
    }
    /**
     * Annotation div element
     */
    createAnnotationDiv(annotation) {
        const annotationDiv = new UiElements_1.DivEl().setClass('annotationDiv').setId(annotation.manualId);
        const annotationTextContainer = new UiElements_1.DivEl().setClass('annotationTextContainer');
        this.nameEl = new UiElements_1.DivEl().setClass('annotationDivName');
        if (annotation.name) {
            this.nameEl.setTextContent(annotation.name);
        }
        this.imageContainerEl = new UiElements_1.DivEl().setClass('annotationImageContainer');
        this.contentEl = new UiElements_1.DivEl().setClass('annotationDivContent');
        if (annotation.content) {
            this.contentEl.setTextContent(annotation.content);
        }
        annotationTextContainer.addChild(this.nameEl);
        annotationTextContainer.addChild(this.imageContainerEl);
        annotationTextContainer.addChild(this.contentEl);
        annotationDiv.addChild(annotationTextContainer);
        return annotationDiv;
    }
    //Update position of annotationPoint
    updatePosition(annotation) {
        const annotationPoint = new three_1.Vector3(annotation.annotationPoint.x, annotation.annotationPoint.y, annotation.annotationPoint.z);
        this.element.position.copy(annotationPoint);
    }
}
exports.AnnotationPopover = AnnotationPopover;
